import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import IconSvg from "../../SharedComponents/IconSvg";

const TitleWithStar = ({ className, text, color }) => {
  return (
    <Row className={className + " justify-content-center"}>
      <Col xs={"auto"}>
        <IconSvg icon={"fourPointStar"} fill={color}></IconSvg>
      </Col>
      <Col
        xs={"auto"}
        className={"fw-semibold text-20 align-content-center  lh-1 mt-1"}
        style={{ color: color ? color : "#274C77" }}
      >
        {text}
      </Col>
    </Row>
  );
};
export default TitleWithStar;
